export enum PropertyType {
	UNIT = "unit",
	PROJECT = "project",
}
